import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import { styled } from "@mui/material";
import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox";

const Checkbox = styled(MuiCheckbox)(({ theme }) => ({
  color: "grey", // Default color when not selected
  "& .MuiSvgIcon-root": { fontSize: 22 },
  "&.Mui-checked": {
    color: theme.palette.success.light, // Color when selected
  },
}));

const RoundCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      icon={<RadioButtonUncheckedOutlinedIcon />}
      checkedIcon={<CheckCircleIcon />}
      sx={{ "& .MuiSvgIcon-root": { fontSize: 22 } }}
      {...props}
    />
  );
};

export default RoundCheckbox;
